export const capitalize = (text: string) =>
  `${text.charAt(0).toUpperCase()}${text.slice(1)}`

export const truncate = (text: string, maxLen: number) => {
  if (text.length <= maxLen) {
    return text
  }

  return `${text.slice(0, maxLen)}...`
}
